import type { RoadmapItem, RoadmapStatus } from './types'

export interface RoadmapColumn {
  title: string
  statuses?: RoadmapStatus[]
  fallback?: true
}

export const columns: RoadmapColumn[] = [
  { title: 'I gang nu', statuses: ['I gang', 'Iværksæt!'] },
  { title: 'Næste tiltag', statuses: ['Næste'] },
  { title: 'Planlagt senere', statuses: ['Planlagt'] },
  { title: 'Afventer', statuses: ['Afventer', 'Kontrollér'] },
  { title: 'I pipeline', fallback: true },
  { title: 'Senest afsluttet', statuses: ['Færdig'] }
]

const assignedStatuses = new Set(columns.flatMap(column => column.statuses ?? []))

export function itemsForColumn(items: RoadmapItem[], column: RoadmapColumn) {
  const matches = column.fallback
    ? items.filter(item => !assignedStatuses.has(item.status as RoadmapStatus))
    : items.filter(item => column.statuses?.includes(item.status as RoadmapStatus))

  return column.title === 'Senest afsluttet' ? matches.slice(0, 5) : matches
}
